import { useTranslation } from 'react-i18next'
import { IconRocket, IconSchedule, IconSearch } from '@machobear/design-system'
import Icon from '@/components/icon'
import { ChatIcon, ContractIcon } from '@/components/icons'
import { Action } from './action'
import { useListingActions } from '../../../context/listing-actions'
import { ScrollableRow } from '../../../components/scrollable-row'
import { useListingData } from '../../../context/listing-data'

export const ActionsSection = () => {
  const { t } = useTranslation()

  const { listingPending, unreadCount, applicationCount } = useListingData()
  const actions = useListingActions()

  return (
    <ScrollableRow>
      <Action
        icon={<Icon id="comments" width={20} height={20} />}
        text={t('Chats')}
        onClick={actions.goToChat}
        counter={unreadCount}
      />
      <Action
        icon={<IconRocket tone="formAccent" />}
        text={t('Sponsored listings')}
        onClick={actions.goToSponsored}
      />
      <Action
        icon={<Icon id="file_import" width={20} height={20} />}
        text={t('Applications')}
        onClick={actions.goToApplications}
        counter={applicationCount}
      />
      <Action
        icon={
          <ContractIcon
            width={20}
            height={20}
            style={{ color: listingPending ? '#ABB3C1' : '#0E131B' }}
          />
        }
        text={t('Contract')}
        onClick={actions.goToContract}
        disabled={listingPending}
      />
      <Action
        icon={<IconSchedule tone="formAccent" />}
        text={t('Showings')}
        onClick={actions.goToShowings}
      />
      <Action icon={<ChatIcon />} text={t('Auto-reply')} onClick={actions.goToAutoReply} />
      <Action
        icon={<IconSearch tone={listingPending ? 'disabled' : 'formAccent'} />}
        text={t('Suggested tenants')}
        onClick={actions.goToSuggestedTenants}
        disabled={listingPending}
      />
      <Action
        icon={<Icon id="notes" width={20} height={20} />}
        text={t('Notes')}
        onClick={actions.goToNotes}
      />
    </ScrollableRow>
  )
}
